import axios from 'axios'
import { buildStorage, setupCache } from 'axios-cache-interceptor'
import localforage from 'localforage'
import { storage } from '@/helpers'
import { API_URL } from '@/constants'
import {logger} from "@/logger/logger";

const defaultOptions = {
  baseURL: API_URL
}

const store = localforage.createInstance({
  driver: [
    localforage.INDEXEDDB,
    localforage.LOCALSTORAGE
  ],
  name: 'api-cache'
})

const defaultCacheOptions = {
  cleanupInterval: 1000,
  storage: buildStorage({
    async find(key: string) {
      const value = await store.getItem<string>(key)

      if (!value) {
        return
      }

      return JSON.parse(value)
    },

    async set(key: string, value: any) {
      await store.setItem(key, JSON.stringify(value))
    },

    async remove(key: string) {
      await store.removeItem(key)
    }
  })
}

const instance = axios.create({
  ...defaultOptions,
  timeout: 10000
})
export const api = setupCache(instance, defaultCacheOptions)

api.interceptors.request.use(
  async config => {
    const token = storage.getItem('token')

    if (!token) {
      const isAuthURL = !(config.url ?? '').replace(config.baseURL ?? '', '').indexOf('auth/')

      if (!isAuthURL) {
        throw new Error('Missing token.')
      }
    }

    const isLoginURL = !(config.url ?? '').replace(config.baseURL ?? '', '').indexOf('auth/login')
    if (token && !config.headers.Authorization && !isLoginURL) {
      config.headers.Authorization = `Token ${token}`
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  res => {
    return res
  },
  error => {
    if (navigator.onLine) {
      logger.error("Axios error", error)
    }

    return Promise.reject(error)
  }
)